import dayjs from "dayjs";

export const interviewSchema = {
  kind: "", // "in-person" | "video-conference"
  record: false,
  status: "pending", // "process" | "finish" | "pending"
  details: "",
  kindDetails: "",
  connectionProvider: "",
  interview: [],
  scheduled: "",
  timeScheduled: "",
  created_at: dayjs().format("YYYY-MM-DD"),
  attachments: [
    // {
    //   "file": "AT235q1480Y1qj2d6055F263JFX83u5u6x",
    //   "name": "img2.png",
    //   "purpose": "General"
    // }
  ],
  witness: [
    // {
    //   "id": 11,
    //   "kind": "witness",
    //   "name": "Miguelon",
    //   "role": "witness"
    // },
  ],
  evaluation: null,
  conclusion: null,
  interviewed: null,
  interviewer: null,
};

export const questionSchema = {
  question: "",
  details: "",
  answer: "",
  answerDetails: "",
};
